import { CustomIconProps } from './art';

export const ProfileCloudEndIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="79" height="46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.188 45.815c9.163-.05 17.206-4.188 21.854-10.415 1.31.523 2.763.81 4.292.803 4.393-.024 8.137-2.483 9.637-5.938.3.1.618.153.946.15 1.87-.01 3.378-1.782 3.366-3.958-.012-2.176-1.538-3.932-3.409-3.922a2.969 2.969 0 0 0-1.256.287c-1.698-3.096-5.267-5.218-9.385-5.196-.233.001-.463.01-.692.024C60.77 7.593 50.34.15 37.94.218 27.85.273 19.12 5.284 14.782 12.582c-1.506-1.26-3.309-1.988-5.242-1.977-5.239.028-9.456 5.47-9.42 12.154.037 6.684 4.313 12.08 9.551 12.051 1.779-.01 3.44-.643 4.857-1.738 4.282 7.595 13.28 12.8 23.659 12.743Z"
      fill="#DFF0FC"
    />
  </svg>
);
